import StringService from "@/services/StringService"
import Vue from "vue"

Vue.filter("phone", value => {
  return StringService.formatPhoneNumber(value)
})